<template lang="pug">
.main-container
  .tabs-content-wrapper()
    aiq-tabs(
      :model-value="$route.name"
      :before-leave="beforeTabLeave"
      type="border-card"
    )
      aiq-tab-pane(
        label="Intents"
        name="IQTools.Intents.Intents"
      )
        router-view(v-if="$route.name === 'IQTools.Intents.Intents'")
      aiq-tab-pane(
        v-if="showAIRecommendations"
        label="AI Recommendations"
        name="IQTools.Intents.IntentRecommendation"
      )
        router-view(v-if="$route.name === 'IQTools.Intents.IntentRecommendation'")
  building-kit-ai-testing
</template>

<script>
import { buildingKitAiTesting } from '../Partials';
import { mapState, mapGetters } from 'vuex';
import { confirmDiscardUnsavedChanges } from '@/libs';

export default {
  name: 'IntentsTabsLayout',
  components: { buildingKitAiTesting },
  computed: {
    ...mapState({
      showAIRecommendations: state => state.featureFlags.FEATURE_FLAGS.SHOW_AI_RECOMMENDATIONS,
      selectedIntent: state => state.intents.selected,
      selectedIntentRecommendation: state => state.intentRecommendations.selected,
      recommendationPristine: state => state.intentRecommendations.pristine,
    }),
    ...mapGetters('intents/formIntent', ['pristine']),
    intentsHasUnsavedChanges() {
      return this.selectedIntent && !this.pristine;
    },
    intentRecommendationHasUnsavedChanges() {
      return this.selectedIntentRecommendation && !this.recommendationPristine;
    },
  },
  methods: {
    async beforeTabLeave(activeName, oldActiveName) {
      if (activeName === oldActiveName) {
        return true;
      }

      if ((oldActiveName === 'IQTools.Intents.Intents' && this.intentsHasUnsavedChanges)
        || (oldActiveName === 'IQTools.Intents.IntentRecommendation' && this.intentRecommendationHasUnsavedChanges)) {
        const confirmedDiscard = await confirmDiscardUnsavedChanges(this);
        if (!confirmedDiscard) {
          return false;
        }
      }

      this.$router.push({ name: activeName });
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>

.tabs-content-wrapper {
  flex: 1;
  min-width: 0;
  height: 100%;

  :deep(.el-tabs) {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  :deep(.el-tabs__content) {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 0;
  }

  :deep(.el-tab-pane) {
    height: 100%;
    min-height: 0;
    min-width: 0;
    overflow: hidden;

    > * {
      height: 100%;
      min-height: 0;
      min-width: 0;
    }
  }
}
</style>
